export const CMD = {
  NOTIFY_URL_CHANGE: 'notifyUrlChanged',
  UPDATE_STATUS_BAR: 'updateStatusBar',
  STORE_AUTH_TOKEN: 'storeAuthToken',
  SNS_CONNECT: 'snsConnect',
  BARCODE_MODE: 'barcodeMode',
  GET_USER_FRIEND_LIST: 'getUserFriendList',
  SHARE_CONTENT: 'shareContent',
} as const;
